export default __webpack_public_path__ + "locales/pt-BR/EmptyView.json?hash=e00dae89c6bb53ec4caaa712688d5437";